import { TwoUtpBlock } from 'shared/components/TwoUtpBlock';
import * as styles from './styles.css';
import { UTP } from './constants';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { BigTitle } from 'shared/components/BigTitle';
import { SubTitle } from 'shared/components/SubTitle';
import { Description } from 'shared/components/Description';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';

export const PrimaryRealEstate: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.FirstMarket}>
          <Block>
            <BigTitle text="Первичная недвижимость" />
            <Description
              text={[
                {
                  value: 'В сегменте новостроек выручка Циан формируется по двум основным направлениям: ',
                },
                { value: 'лидогенерация', anchorLink: 'leadGeneration' },
                { value: ' и ' },
                { value: 'медийная реклама', anchorLink: 'mediaAd' },
                {
                  value:
                    '. Эти инструменты почти всегда используются совместно: одно работает на конверсию в целевые обращения, другое — на узнаваемость. Такое сочетание обеспечивает комплексное продвижение проектов и повышает эффективность маркетинга застройщиков.',
                },
              ]}
            />
          </Block>
          <Element name={ENavigation.ClientsDirection}>
            <div className={styles['clients-direction']}>
              <SubTitle text="Клиенты направления:" />
              <TwoUtpBlock blocks={UTP} />
            </div>
          </Element>
        </Element>
      </Wrapper>
    </div>
  );
};
